export default __webpack_public_path__ + "static/media/video-placeholder.ca40af56.jpg";